import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Checkmark = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M19.358 2.981c.788.702.86 1.912.163 2.704L9.68 16.855a1.9 1.9 0 0 1-2.773.084l-6.35-6.383a1.92 1.92 0 0 1 0-2.708 1.9 1.9 0 0 1 2.695 0l5.081 5.043 8.336-9.746a1.9 1.9 0 0 1 2.69-.164Z" }) }));
});
Checkmark.displayName = 'Checkmark';
Checkmark.__iconComponentType = 'standard';
export default Checkmark;
//# sourceMappingURL=Checkmark.js.map